import { notification } from "antd";

import history from "../../routes/history";
import api from "../api";
import ApiException from "../exception/ApiException";


const registerLocal = async (values) => {
  try {
    await api.post("locaisviagens", values);
    history.push("/locais");
    notification.open({
      message: "Local de embarque e desembarque adicionado com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const getLocalViagem = async (id) => {
  try {
    const { data } = await api.get(`locaisviagens/${id}`);
    return data;
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const deleteLocalViagem = async (id) => {
  try {
    await api.delete(`locaisviagens/${id}`);
    notification.open({
      message: "Local de embarque e desembarque deletado com sucesso",
    });
  } catch (error) {
    notification.open({
      message: error.response.data.error,
    });
  }
};

const getLocalViagens = async (page, filter = "", paginated = "") => {
  const { data: motoristas } = await api.get(
    `locaisviagens?page=${page}&filter=${filter}&paginated=${paginated}`
  );
  return motoristas;
};

const updateLocalViagem = async (local, values) => {
  try {
    values.id = local.id;
    await api.put("locaisviagens", values);
    history.push("/locais");
    notification.open({
      message: "Local de embarque e desembarque atualizado com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

export {
  registerLocal,
  deleteLocalViagem,
  getLocalViagem,
  getLocalViagens,
  updateLocalViagem,
};
